/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_DetectionInputs */



/**
* | output |
* | --- |
* | "Error Detection" |
*
* @param {Error_DetectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_detection = /** @type {((inputs?: Error_DetectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_DetectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Détection des erreurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehlererkennung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rilevamento degli errori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обнаружение ошибок")
	if (locale === "es") return /** @type {LocalizedString} */ ("Detección de errores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("错误检测")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エラー検出")
	if (locale === "hi") return /** @type {LocalizedString} */ ("त्रुटि का पता लगाना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Detecção de erro")
	return /** @type {LocalizedString} */ ("Error Detection")
});